import React from 'react';
import { useTranslation } from 'react-i18next';
import { Menu } from 'shared/assets/icons';
import { Colors, IconButton, Sizes } from 'shared/components/ui/icon-button';
import {
  useOpenMobileSideNavigation,
  useOpenSideNavigation,
} from 'shared/contexts/navigation';
import { useElectron } from 'shared/hooks/use-is-mac';

import * as Styled from './top-bar-base.style';

type AppBarProps = {
  hideBorder?: boolean;
  borderColor?: string;
  smallLeftPadding?: boolean;
  mobileNavigationSlot?: React.ReactNode;
  children?: React.ReactNode;
};

export const TopBarBase: React.FC<AppBarProps> = ({
  hideBorder,
  borderColor,
  smallLeftPadding,
  mobileNavigationSlot,
  children,
}) => {
  const { t } = useTranslation();
  const [sideNavOpen, toggleSideNav] = useOpenSideNavigation();
  const [_, toggleMobileSideNav] = useOpenMobileSideNavigation();
  const { isMac } = useElectron();

  return (
    <Styled.Container $hideBorder={!!hideBorder} $borderColor={borderColor}>
      <Styled.ContentContainer
        $isElectronMac={isMac}
        $menuDisplayed={sideNavOpen}
        $smallLeftPadding={smallLeftPadding || !sideNavOpen}
      >
        <Styled.SmallScreenIconButton>
          <IconButton
            aria-label={t('general.menu.labels.open')}
            onClick={toggleMobileSideNav}
            size={Sizes.Medium}
            icon={Menu}
            color={Colors.Default}
            preventDrag
          />
        </Styled.SmallScreenIconButton>

        {!sideNavOpen && (
          <Styled.SmallScreenUpIconButton>
            <IconButton
              aria-label={t('general.menu.labels.open')}
              onClick={toggleSideNav}
              size={Sizes.Medium}
              icon={Menu}
              color={Colors.Default}
              preventDrag
            />
          </Styled.SmallScreenUpIconButton>
        )}

        {!!children && <Styled.Content>{children}</Styled.Content>}
      </Styled.ContentContainer>
      {!!mobileNavigationSlot && (
        <Styled.MobileNavigation>
          {mobileNavigationSlot}
        </Styled.MobileNavigation>
      )}
    </Styled.Container>
  );
};
